import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function AdminAppointments() {
  const [clients, setClients] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [filters, setFilters] = useState({ client_id: "all", start: "", end: "" });

  useEffect(() => { api.get("/clients").then(({ data }) => setClients(data)); }, []);
  useEffect(() => {
    const qs = new URLSearchParams();
    if (filters.client_id && filters.client_id !== "all") qs.set("client_id", filters.client_id);
    if (filters.start) qs.set("start_date", filters.start);
    if (filters.end) qs.set("end_date", filters.end);
    api.get(`/appointments?${qs.toString()}`).then(({ data }) => setAppointments(data));
  }, [filters]);

  const clientName = (id) => clients.find((c) => c.id === id)?.name || "—";

  return (
    <div className="space-y-6" data-testid="admin-appointments">
      <div>
        <p className="text-label">Care Coordination</p>
        <h1 className="font-display text-3xl font-bold tracking-tight">Medical/Dental Appointments</h1>
      </div>

      <Card className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div>
            <Label className="text-label">Client</Label>
            <Select value={filters.client_id} onValueChange={(v) => setFilters({ ...filters, client_id: v })}>
              <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Clients</SelectItem>
                {clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <div><Label className="text-label">Start</Label><Input type="date" value={filters.start} onChange={(e) => setFilters({ ...filters, start: e.target.value })} className="mt-1" /></div>
          <div><Label className="text-label">End</Label><Input type="date" value={filters.end} onChange={(e) => setFilters({ ...filters, end: e.target.value })} className="mt-1" /></div>
        </div>
      </Card>

      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Client</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Doctor / Clinic</TableHead>
              <TableHead>Details</TableHead>
              <TableHead>Follow-up</TableHead>
              <TableHead>Logged By</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {appointments.length === 0 && (
              <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">No appointments.</TableCell></TableRow>
            )}
            {appointments.map((a) => (
              <TableRow key={a.id}>
                <TableCell className="font-medium">{a.date}</TableCell>
                <TableCell>{clientName(a.client_id)}</TableCell>
                <TableCell><Badge variant="secondary">{a.appt_type}</Badge></TableCell>
                <TableCell>{a.doctor_clinic || "—"}</TableCell>
                <TableCell className="max-w-xs"><p className="line-clamp-2">{a.important_details}</p></TableCell>
                <TableCell className="max-w-xs"><p className="line-clamp-2 text-muted-foreground">{a.follow_up || "—"}</p></TableCell>
                <TableCell className="text-xs text-muted-foreground">{a.provider_name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
